


















































































































































import { Vue, Component, Prop, Mixins, Ref } from "vue-property-decorator";
import Page from "@/views/Page.vue";
import DataTable from "@monade/vue-components/src/components/VDataTable.vue";
import Paginator from "@monade/vue-components/src/components/VPaginator.vue";
import { Quotation } from "../../models";
import Search from "@/components/VEntrySearch.vue";
import QuotationsMixin from "../../mixins/http/QuotationsMixin";
import StatusBadge from "@/components/Quotation/StatusBadge.vue";
import { NoCache, RegisterHttp } from "../../utils/Decorators";
import RequestData from "@/store/types/RequestData";
import { currentUserStore } from "@/store/typed";
import EditQuotationModal from "@/components/Quotation/Edit.vue";
import Filters from "@/components/Quotation/Filters.vue";
import Percent from "@/filters/Percent";
import UsersMixin from "@/mixins/http/UsersMixin";
import QuotationCode from "@/filters/QuotationCode";

@Component({
  filters: {
    Percent,
    QuotationCode,
  },
  components: {
    Page,
    DataTable,
    Paginator,
    Search,
    StatusBadge,
    EditQuotationModal,
    Filters,
  },
})
export default class QuotationList extends Mixins(QuotationsMixin) {
  static readonly getQuotationsTag = "get_Quotations_tag";
  @RegisterHttp(QuotationList.getQuotationsTag)
  readonly getQuotationsRequest: RequestData;
  private items: Quotation[] = [];
  private search: string = null;
  private showFilters = false;
  page = 1;
  private filter = null;

  @Ref() editModal!: EditQuotationModal;

  get grandDiscountSlotName() {
    return "column_lastRevision.grandDiscount";
  }

  get grandTotalSlotName() {
    return "column_lastRevision.grandTotal";
  }

  get columns() {
    const columns: Array<{ name: string; label: string }> = [];
    columns.push({ name: "status", label: "Status" });
    columns.push({ name: "code", label: "Number" });
    columns.push({ name: "client.businessName", label: "Client" });
    columns.push({ name: "name", label: "Project name" });
    columns.push({ name: "lastRevision.grandTotal", label: "Total" });
    columns.push({ name: "lastRevision.grandDiscount", label: "Discount" });
    columns.push({ name: "lastRevision.user.fullname", label: "User" });
    columns.push({ name: "actions", label: "" });
    return columns;
  }

  onReset() {
    this.page = 1;
    this.$router.replace({ query: {} }).catch(() => {});
    this.filter = null;
    this.loadQuotations();
  }

  get hasFilters() {
    return !!(Object.keys(this.filter || {}).length > 0 || this.search);
  }

  get hasItems() {
    return this.items?.length > 0;
  }

  applyFilters(value) {
    this.page = 1;
    this.filter = {};
    if (value.filter) {
      Object.assign(this.filter, value.filter);
    }
    this.$router.replace({ query: { ...this.filter } }).catch(() => {});
    this.loadQuotations();
  }

  get statuses() {
    return Quotation.statuses;
  }

  openDetail(item: Quotation, edit: boolean) {
    this.$router.push({
      name: "quotation_edit",
      params: { id: item.id },
      query: { edit: edit ? "1" : "0" },
    });
  }

  goToQuotation(item: Quotation) {
    this.$router.push({ name: "quotation_show", params: { id: item.id } });
  }

  onCreated(item: Quotation) {
    this.items.unshift(item);
    this.openDetail(item, true);
  }

  onUpdated(item: Quotation) {
    const index = this.items.findIndex((o) => item.id === o.id);
    this.$set(this.items, index, item);
  }

  onSearchCanceled() {
    this.page = 1;
    this.search = null;
    this.loadQuotations();
  }

  onSearched(items) {
    this.page = 1;
    this.items = items.items;
  }
  get company() {
    return currentUserStore.company;
  }

  @NoCache
  get payload() {
    const data: any = {
      page: this.page,
      companyId: this.company?.slug,
      filter: { ...this.filter },
    };

    if (this.search) {
      data.filter.term = this.search;
    }
    return data;
  }

  async searchQuotations(name: string) {
    if (name.trim().length > 0) {
      this.search = name;
      const products = await this.getQuotations(
        this.payload,
        QuotationList.getQuotationsTag
      );
      return products;
    }
  }

  async loadQuotations() {
    this.items = await this.getQuotations(
      this.payload,
      QuotationList.getQuotationsTag
    );
  }

  onPageChange(page) {
    this.page = page;
    this.loadQuotations();
  }

  openCreateModal() {
    this.editModal.create(this.company);
  }

  openEditModal(item: Quotation) {
    this.editModal.edit(item);
  }

  get loading() {
    return this.getQuotationsRequest?.loading;
  }

  get meta() {
    return this.getQuotationsRequest?.meta;
  }
}
